import { KeyboardEvent } from 'react';

export enum Keys {
  ENTER = 'Enter',
  SPACE = ' ',
}

export const useKeypress = <T>(key: Keys | Keys[] = Keys.ENTER, callback: () => void) => {
  return (event: KeyboardEvent<T>) => {
    if (Array.isArray(key) && key.some(k => k === event.key)) {
      event.preventDefault();
      callback();
    }
    if (event.key === key) {
      event.preventDefault();
      callback();
    }
  };
};
